import AoneService from "./axiosbase";

export const postSla = async (data) => {
  try {
    return await AoneService.post("products/api/v1/products/", data);
  } catch (error) {
    return error;
  }
};

export const editSla = async (data) => {
  try {
    return await AoneService.put("products/api/v1/products/", data);
  } catch (error) {
    return error;
  }
};

export const getSla = async () => {
  try {
    return await AoneService.get("products/api/v1/products");
  } catch (error) {
    return error;
  }
};

export const deleteSla = async (id) => {
  try {
    return await AoneService.delete(`products/api/v1/products/${id}`);
  } catch (error) {
    return error;
  }
};

export const getOrder = async (params) => {
  try {
    return await AoneService.get("orders-adapter/api/v1/order?" + params);
  } catch (error) {
    return error;
  }
  };

export const postOrders = async (data) => {
  try {
    return await AoneService.post("orders-adapter/api/v1/order", data);
  } catch (error) {
    return error;
  }
};

export const postBulkOrder = async (data) => {
  try {
    return await AoneService.post(
      "orders-adapter/api/v1/order/bulk-upload",
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

export const downloadSample = async () => {
  try {
    return await AoneService.get(
      "orders-adapter/api/v1/order/download/upload-sample",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const printBill = async (data) => {
  try {
    return await AoneService.post(
      "print/waybill/print?url=true",
      data
      // {
      //   responseType:'blob'
      // }
    );
  } catch (error) {
    return error;
  }
};

export const postMsg = async (data) => {
  try {
    return await AoneService.post("notification/v1/api/sms/bulk", data);
  } catch (error) {
    return error;
  }
};

export const printBulkBill = async (data) => {
  try {
    return await AoneService.post(
      "print/waybill/v2/print?url=true",
      data
      // {
      //   responseType:'blob'
      // }
    );
  } catch (error) {
    return error;
  }
};

export const downloadSampleSms = async () => {
  try {
    return await AoneService.get("notification/v1/api/sms/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const uploadReciver = async (data) => {
  try {
    return await AoneService.post("notification/v1/api/sms/upload", data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

export const getSmsType = async () => {
  try {
    return await AoneService.get("notification/v1/api/sms/type");
  } catch (error) {
    return error;
  }
};

export const downloadSamplebulk = async () => {
  try {
    return await AoneService.get("print/waybill/v2/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const uploadBulkprint = async (data) => {
  try {
    return await AoneService.post("print/waybill/v2/upload?url=true", data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

export const getZidProducts = async (params) => {
  try {
    return await AoneService.get("zid/api/v1/products/?" + params);
  } catch (error) {
    return error;
  }
};

export const syncZidProduct = async () => {
  try {
    return await AoneService.get("zid/api/v1/products/sync/all");
  } catch (error) {
    return error;
  }
};

export const putZidProduct = async (params, data) => {
  try {
    return await AoneService.patch("zid/api/v1/products/" + params, data);
  } catch (error) {
    return error;
  }
};

export const getZidProductsByStoreId = async (params) => {
  try {
    return await AoneService.get("zid/api/v1/products/" + params);
  } catch (error) {
    return error;
  }
};

export const syncZidProductByStoreId = async (params) => {
  try {
    return await AoneService.get("zid/api/v1/products/sync/" + params);
  } catch (error) {
    return error;
  }
};

export const getZidMerchants = async () => {
  try {
    return await AoneService.get("zid/api/v1/merchants/");
  } catch (error) {
    return error;
  }
};

export const getZidMerchantsByStoreId = async (params) => {
  try {
    return await AoneService.get("zid/api/v1/merchants/" + params);
  } catch (error) {
    return error;
  }
};

export const postZidMerchants = async (data) => {
  try {
    return await AoneService.post("zid/api/v1/merchants", data);
  } catch (error) {
    return error;
  }
};

export const putZidMerchants = async (params, data) => {
  try {
    return await AoneService.put("zid/api/v1/merchants/" + params, data);
  } catch (error) {
    return error;
  }
};

//get employees
export const getEmployee = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees" + params
    );
  } catch (error) {
    return error;
  }
};

//post employees
export const postEmployee = async (data) => {
  try {
    return await AoneService.post("employees/api/v1/employees", data);
  } catch (error) {
    return error;
  }
};

//edit employees
export const editEmployees = async (params, data) => {
  try {
    return await AoneService.patch(
      `employees/api/v1/employees/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//export employees
export const exportEmployee = async (params) => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//employee template
export const getEmployeesTemplate = async () => {
  try {
    return await AoneService.get(
      "employees/api/v1/employees/template",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//employee import
export const importEmployees = async (data) => {
  try {
    return await AoneService.post(
      `employees/api/v1/employees/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
